module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Category")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cat.category),
      expression: "cat.category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.cat.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cat.category = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Save"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-714b663c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/EditCategory.vue
// module id = 513
// module chunks = 1